/**
 * Created by Alex Aguilar on 5/24/2016.
 */
(function(){
    'use strict'

    angular
        .module('completeAir')
        .factory('linkService', ['$state', function($state){
            var service = {
                getLinkId: getLinkId,
                getLinkIds: getLinkIds,
                reloadRoute: reloadRoute,
                getCurrentRouteName: getCurrentRouteName
            }
            return service;

            function getLinkId(url){
              if (url == undefined) return;
                var split = url.split("/");
                return split[split.length - 1];
            }

            function getLinkIds(url){
                var split = url.split("/"),
                    splitArray = split[split.length - 1],
                    ids = splitArray.split("_").map(function(id) {
                        return parseInt(id, 10);
                    });
                return ids;
            }

            function reloadRoute(route, data){
                $state.go(route, data, { reload: true });
            }

            function getCurrentRouteName(){
                return $state.current.name;
            }
        }]);
})();
